import { AuthenticateResultModel } from "@api";
import { Edition, MarketingSource, PaymentMethod } from "../../api/proxies";

export const ActionTrial = "action_trial";

export const ActionRegister = "action_register";

export const ActionCheckout = "action_checkout";

export const CreditCardPaymentMethod = PaymentMethod._3;

export const ErrorTypeValidationError = "https://api.vsaude.com.br/validation-error";

export class AvailableAdditionalItemSection {
    code: string | undefined;

    title: string | undefined;

    items: AvailableAdditionalItem[] | undefined;
}

export class AvailableAdditionalItem {
    section: string;

    id: string | undefined;

    title: string | undefined;

    description: string | undefined;

    price: number;

    quantity: number;
}

export class AdditionalItem {
    section: string;

    id: string;

    title: string;

    price: number | undefined;

    quantity: number;

    unit: number;

    get subtotal() {
        return this.quantity * this.price;
    }
}

export interface IProductFeature {
    id: number;

    title: string;

    description: string[];

    price: number;
}

export class AvailableProduct {
    id: string;

    title: string;

    price: number;

    installmentPrice?: number | undefined;

    features?: IProductFeature[] | undefined;

    get featuresPrice() {
        return this.features.reduce((acc, curr) => {
            acc += curr.price;
            return acc;
        }, 0);
    }
}

export enum BillingCycle {
    Monthly = 1,
    Annual = 2,
}

export class CreditCard {
    flag: string;

    token: string;

    number: string;

    expirationMonth: string;

    expirationYear: string;

    securityCode: string;

    ownerName: string;
}

export class Address {
    postalCode: string | undefined;
    formattedAddress: string | undefined;
    reference: string | undefined;
    complement: string | undefined;
    number: number | undefined;
    neighborhood: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
}

export class Buyer {
    id: string | undefined;

    fiscalIdentifier: string;

    name: string;

    email: string;

    mobilePhone: string;

    password: string;

    creatorProfile: number;

    address: Address;
}

export class BillableProduct {
    id: string | undefined;
    quantity: number;
    price: number;
}

export class OrderBump {
    items: any[];
    paymentMethod: PaymentMethod;
    discountVoucher: string;
    price: number;
    discount: number;
    maxNumberOfInstallments: number;
}

export interface IEditionsState {
    popular: {
        monthly: string;
        annual: string;
    };

    editions: Edition[];

    selectedEdition: Edition;

    selectedEditionHash: string | undefined;

    loading: boolean;

    billingCycle: BillingCycle;

    creditCard: CreditCard | undefined;

    totalChargedNow: number;

    total: number;

    buyer: Buyer;

    step: number;

    action: string;

    trialDays: number;

    paymentMethod: PaymentMethod;

    availableAdditionalItems: AvailableAdditionalItemSection[];

    additionalItems: AdditionalItem[];

    additionalProducts: AvailableProduct[];

    orderBump: OrderBump;

    authenticateResultModel: AuthenticateResultModel;

    marketingSource: MarketingSource;
}
